import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { client } from "../lib/client";
import { collectionsQuery } from "../lib/queries";
// import MainMenu from "./MainMenu";
import SanityImg from "./SanityImg";

function CollectionsList() {
  const [collections, setCollections] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    client.fetch(collectionsQuery).then((data) => {
      if (!cancelled) setCollections(Array.isArray(data) ? data : []);
    });

    return () => {
      cancelled = true;
    };
  }, []);

  const handleCollectionClick = (slug) => {
    const handle = slug?.current;
    if (!handle) return;
    navigate(`/collections/${handle}`);
  };

  return (
    <>
      {/* <MainMenu /> */}

      <div className="w-full bg-white flex flex-col items-start justify-start px-6 py-2 uppercase italics mt-5 md:mt-10">
        {collections.map((collection, index) => {
          const positionClasses =
            index % 3 === 0
              ? "ml-16"
              : index % 3 === 1
              ? "ml-auto mr-16"
              : "mx-auto";

          return (
            <div
              key={collection.slug?.current || collection._id || index}
              className={`group relative w-3/4 md:w-2/5 mb-12 cursor-pointer ${positionClasses}`}
              onClick={() => handleCollectionClick(collection.slug)}
              role="link"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  handleCollectionClick(collection.slug);
                }
              }}
              aria-label={`View collection: ${collection.title || "Collection"}`}
            >
              <SanityImg
                image={collection?.collectionImage}
                alt={collection?.title ? `Image for ${collection.title}` : "Collection image"}
                priority={index === 0}
                className="w-full h-auto"
                sizes="(max-width: 768px) 80vw, 40vw"
                maxW={1200}
              />

              <p
                className="
                  mt-1 text-sm font-light m-4 italic
                  transition-transform duration-300 ease-out
                  group-hover:-translate-x-4
                "
              >
                {collection.title}
              </p>
            </div>
          );
        })}
      </div>
    </>
  );
}

export default CollectionsList;
